import { render, staticRenderFns } from "./UserCreation.vue?vue&type=template&id=533958ce&"
import script from "./UserCreation.vue?vue&type=script&lang=js&"
export * from "./UserCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533958ce')) {
      api.createRecord('533958ce', component.options)
    } else {
      api.reload('533958ce', component.options)
    }
    module.hot.accept("./UserCreation.vue?vue&type=template&id=533958ce&", function () {
      api.rerender('533958ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/UserCreation.vue"
export default component.exports